<template>
  <div>
    <v-container class="pt-8 px-10">
      <h1 class="display-1 mb-4">Randoms</h1>
      <v-layout row wrap>
        <v-flex 
          v-for="profile in sortedProfiles" 
          :key="profile.id"
          class="pa-2"
          xs12 sm6 md4 lg3
        >
          <v-card outlined>
            <v-card-title class="subtitle-1 pb-0">
              {{ profile.name }}
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn icon route :to="profile.route">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon @click="deleteProfile(profile.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { fbMemberName } from '../utils'

export default {
  name: 'FbRandoms',
  injectModels: ['Store'],
  data() {
    return {
      profiles: this.Store.fb.profiles,
      sort: 'firstName'
    }
  },
  computed: {
    sortedProfiles() {
      const profiles = Object.keys(this.profiles)
        .filter(id => id.startsWith('RAND_'))
        .map(id => ({ 
          id, 
          name: fbMemberName(this.profiles[id]),
          route: `/fb-profiles/${id}`
        }))

      if (!this.sort)
        return profiles
        
      return profiles.sort((a, b) => {
        a = a[this.sort]
        b = b[this.sort]
        // Case-insensitive lexi sorting
        if (typeof a === 'string' && typeof b === 'string')
          [a, b] = [a, b].map(s => s.toLowerCase())

        return a > b
      })
    }
  },
  methods: {
    deleteProfile(id) {
      this.$delete(this.Store.fb.profiles, id)
    }
  }
}
</script>